import api from './api'

/**
 * Sincronização device → nuvem dos dados de apps em ManagedDevice + tela (Application/Template).
 *
 * Endpoints (DeviceAppSyncController):
 *  - /api/managed-devices/{id}/app-syncs (lista/cria)
 *  - /api/app-syncs/{id} (put/delete), /api/app-syncs/{id}/run
 *  - /api/managed-devices/{id}/app-data/{tables|records|versions|live}
 *  - /api/managed-devices/{id}/screen (Application + Template webui)
 */
export const appSyncApi = {
  list: async (deviceId) => (await api.get(`/managed-devices/${deviceId}/app-syncs`)).data,
  create: async (deviceId, data) => (await api.post(`/managed-devices/${deviceId}/app-syncs`, data)).data,
  update: async (syncId, data) => (await api.put(`/app-syncs/${syncId}`, data)).data,
  remove: async (syncId) => {
    await api.delete(`/app-syncs/${syncId}`)
  },
  // A primeira carga de um device com histórico grande pode levar alguns minutos.
  run: async (syncId) => (await api.post(`/app-syncs/${syncId}/run`, null, { timeout: 600000 })).data,

  tables: async (deviceId) => (await api.get(`/managed-devices/${deviceId}/app-data/tables`)).data,
  live: async (deviceId, refresh = false) =>
    (await api.get(`/managed-devices/${deviceId}/app-data/live`, { params: { refresh } })).data,

  getScreen: async (deviceId) => (await api.get(`/managed-devices/${deviceId}/screen`)).data,
  setScreen: async (deviceId, data) => (await api.put(`/managed-devices/${deviceId}/screen`, data)).data,
}
